import { GroupBase, OptionProps, components } from 'react-select';
import { Avatar, Checkbox } from 'src/components/atoms';
import { FormState } from 'src/types';
import { returnDashIfNoValue } from 'src/utils';
import { getInitials } from 'src/utils/getInitials';
import {
  ExistingTeamMemberText,
  InviteUserOptionStyled,
  UserDetailsText,
  UserNameText,
} from './InviteUserOption.styles';

export interface InviteUserDropdownOption {
  label: string;
  value: string | number;
  role?: string | null;
  site?: string | null;
  country?: string | null;
  teamMember?: boolean;
  tagStateWhenSelected?: FormState;
  isSuperAdmin?: boolean;
}

export const InviteUserOption = (
  props: OptionProps<
    InviteUserDropdownOption,
    boolean,
    GroupBase<InviteUserDropdownOption>
  >,
) => {
  const userRole = returnDashIfNoValue(props.data.role);
  const userSite = returnDashIfNoValue(props.data.site);
  const userCountry = returnDashIfNoValue(props.data.country);

  const renderRowContent = () => {
    if (props.data.teamMember) {
      return (
        <ExistingTeamMemberText>
          Already added to the team
        </ExistingTeamMemberText>
      );
    } else {
      return (
        <>
          <UserDetailsText title={userRole}>{userRole}</UserDetailsText>
          <UserDetailsText title={userSite}>{userSite}</UserDetailsText>
          <UserDetailsText title={userCountry}>{userCountry}</UserDetailsText>
        </>
      );
    }
  };
  return (
    <components.Option {...props} isSelected={Boolean(props.data.teamMember)}>
      <InviteUserOptionStyled data-testid={`user-${props.data.value}`}>
        <Avatar variant="text" text={getInitials(props.label)} size="medium" />
        <UserNameText title={props.label}>
          {returnDashIfNoValue(props.label)}
        </UserNameText>
        {renderRowContent()}
        <Checkbox
          checked={props.isSelected || Boolean(props.data.teamMember)}
          onChange={() => {}}
          disabled={props.data.teamMember}
        />
      </InviteUserOptionStyled>
    </components.Option>
  );
};
